/**
 * datepicker creates the window.initDatepicker function.
 *
 * window.initDatepicker creates a datepicker on the given element, according to the Visual Design.
 * If a parameter is not given, it is replaced with a dummy variable.
 * - id: Int          (Id of element to create the datepicker on)
 *
 * Dependencies
 * - Flatpickr https://flatpickr.js.org/getting-started/
 *
 * Related Issues
 * - NMN-134 RFC: datepicker month & year selector https://service.thevalley.nl/browse/NMN-134
 */

function datepicker() {
	function initDatepickerOnElement(el, options) {
		// previous jQuery UI settings:
		// el.datepicker({
		// 	showOtherMonths: true,
		// 	selectOtherMonths: true,
		// 	changeYear: true,
		// 	yearRange: '-110:-0', // Note that this option only affects what appears in the drop-down,
		// 	minDate: '-110y', // To restrict which dates may be selected use the minDate and/or maxDate options
		// 	dateFormat: window.currentDateFormat || 'dd-mm-yy',
		// 	beforeShow: function(el, dp){
		// 		if (el.value != '') {
		// 			el.value = window.formatDate(el.value);
		// 		}
		// 	},
		// 	onSelect: function ()
		// 	{
		// 		// The 'this' keyword refers to the input
		// 		this.focus();
		// 		//remove validation error if set.
		// 		$(this).closest('div').removeClass('validation-error');
		// 	}
		// });
		// set each picker individually to the items own value
		$(el).each(function() {
			const defaults = {
				enableTime: false,
				dateFormat: 'Y-m-d',
				defaultDate: $(this).val(),
				allowInput: true,
				time_24hr: true // optional
			};
			const settings = jQuery.extend({}, defaults, options);
			$(this).flatpickr(settings);
		});
	}

	function initDatepicker(id) {
		const selector = id != null ? `#${id}` : '.js-datepicker';
		if ($(selector).length == 0) {
			return;
		}
		initDatepickerOnElement($(selector));
	}

	window.initDatepicker = initDatepicker;
	window.initDatepickerOnElement = initDatepickerOnElement;
}
datepicker();
